module.exports = __webpack_public_path__ + "static/media/hallo2.7cb44011.jpg";